import { Blur, Remote } from "@/api/loaderRemote";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const RecentPosts = ({ posts }) => (
  <div className="flex flex-col mb-4 xl:mb-20 lg:mb-14 md:mb-10">
    <span className="text-[#586474] font-extrabold leading-normal mb-4">
      Son Yazılar
    </span>
    {posts?.map((post, index) => (
      <Link
        key={index}
        href={post.url}
        prefetch={false}
        className="flex relative rounded-md overflow-hidden mb-2 after:content-[''] after:absolute after:inset-0 after:w-full after:h-full after:bg-gradient-to-b after:from-[rgba(0,26,66,0.2)] after:to-[#001A42]"
      >
        <Image
          src={post.resim}
          width={413}
          height={92}
          loader={Remote}
          blurDataURL={Blur(post.resim)}
          className="object-cover w-full h-[92px]"
          alt={post.title}
        />
        <span className="absolute z-10 text-lg font-bold text-white -translate-y-1/2 left-2 top-1/2">
          {post.baslik}
        </span>
      </Link>
    ))}
  </div>
);

export default RecentPosts;
